import { IoMdPersonAdd } from "react-icons/io";
import { Link } from "react-router-dom";
import Table from "../list/Table";
import moment from "moment";
import { DATE_FORMAT } from "../defines";
import objectPath from "object-path";
import { useTranslation } from "react-i18next";

const Index = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          {t("log.title")}
        </div>
      </div>
      <div className="px-4">
        <Table
          url={`/log/table`}
          sort={{ _id: -1 }}
          columns={[
            {
              label: t("log.title"),
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, info }) => {
                return (
                  <Link to={`view/${_id}`}>
                    <div className="text-primary underline font-bold">
                      {info}
                    </div>
                  </Link>
                );
              },
            },
            {
              label: t("date"),
              sort: true,
              key: "created",
              filter: {
                type: "date",
              },
              render: ({ _id, created }) => {
                return (
                  // <Link to={`view/${_id}`}>
                  <div className="">{moment(created).format(DATE_FORMAT)}</div>
                  // </Link>
                );
              },
            },
            {
              label: t("log.url"),
              key: `originalUrl`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: `Method`,
              key: `method`,
              sort: true,
              filter: {
                type: "select",
                items: [
                  {
                    label: "POST",
                    value: "POST",
                  },
                  {
                    label: "GET",
                    value: "GET",
                  },
                  {
                    label: "PUT",
                    value: "PUT",
                  },
                  {
                    label: "DELETE",
                    value: "DELETE",
                  },
                ],
              },
            },
            {
              label: t("log.ip"),
              key: `ip`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("log.user"),
              key: `createdby`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ createdby }) => {
                return (
                  <div className="">{objectPath.get(createdby, "email")}</div>
                );
              },
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Index;
